import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import AdminPartnerApprovals from './AdminPartnerApprovals';
import AdminCatalogApprovals from './AdminCatalogApprovals';
import AdminCommission from './AdminCommission';
import { market } from '../lib/api';

function AuditLog() {
  const [items, setItems] = useState(null);
  useEffect(() => { market.auditLog().then(d => setItems(d.items)).catch(() => setItems([])); }, []);
  if (!items) return <Loader2 className="w-5 h-5 animate-spin"/>;
  return (
    <div data-testid="admin-audit-log" className="card-soft overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="text-left text-xs uppercase text-ink/60"><tr><th className="p-2">When</th><th className="p-2">Admin</th><th className="p-2">Action</th><th className="p-2">Note</th></tr></thead>
        <tbody>{items.map(i => <tr key={i.id} className="border-t border-border"><td className="p-2 whitespace-nowrap">{new Date(i.at).toLocaleString()}</td><td className="p-2">{i.actor_name || i.actor_id}</td><td className="p-2">{i.action}</td><td className="p-2">{i.note}</td></tr>)}</tbody>
      </table>
      {items.length === 0 && <p className="p-3 text-sm text-ink/60">No admin actions yet.</p>}
    </div>
  );
}

const SUBS = [['partners', 'Partner registrations'], ['catalog', 'Product listings'], ['commission', 'Commission & payouts'], ['audit', 'Audit log']];

export default function AdminApprovals() {
  const [sub, setSub] = useState('partners');
  return (
    <div className="mt-6 space-y-4" data-testid="admin-approvals">
      <div className="flex gap-4 border-b border-border">
        {SUBS.map(([v, l]) => (
          <button key={v} data-testid={`approvals-sub-${v}`} onClick={() => setSub(v)} className={`pb-2 text-sm font-semibold border-b-2 ${sub === v ? 'border-[#E67E22] text-[#D35400]' : 'border-transparent text-ink/60'}`}>{l}</button>
        ))}
      </div>
      {sub === 'partners' && <AdminPartnerApprovals/>}
      {sub === 'catalog' && <AdminCatalogApprovals/>}
      {sub === 'commission' && <AdminCommission/>}
      {sub === 'audit' && <AuditLog/>}
    </div>
  );
}
